import { Injectable, Component, TemplateRef } from '@angular/core';
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ErrorPopUpComponent } from "../Components/PopUps/ErrorPopUpComponent";
import { ConfirmComponent } from '../Components/PopUps/ConfirmComponent';
import { LogInErrorPopUpComponent } from '../Components/PopUps/LogInErrorPopUpComponent';


@Injectable()
export class DialogService {

	constructor(private modalService: NgbModal) { }

	alreadyLogInError: boolean = false;
	showLogInError() {
		var thisHolder = this;
		if (!thisHolder.alreadyLogInError) {
			thisHolder.alreadyLogInError = true;
			let modal: NgbModalRef = thisHolder.modalService.open(LogInErrorPopUpComponent);
			modal.result.then(() => {
				thisHolder.alreadyLogInError = false;
			});
		}
	}
	error(msg: string, error: string) {
		let modal: NgbModalRef = this.modalService.open(ErrorPopUpComponent);

		modal.componentInstance.errorBody = msg;
		modal.componentInstance.errorStack = error;
	}

	confirm(msg: string): Promise<boolean> {
		let modal: NgbModalRef = this.modalService.open(ConfirmComponent);
		modal.componentInstance.message = msg || 'Are you sure?';
		return modal.result;
	}

	message(msg: string, title: string): Promise<any> {
		let modal: NgbModalRef = this.modalService.open(ErrorPopUpComponent);

		if (title) {
			modal.componentInstance.errorTitle = title;
		}
		modal.componentInstance.errorBody = msg;
		return modal.result;
	}


	toasts: any[] = [];

	showToast(text: string, options: any = {}) {
		this.toasts.push({ text: text, ...options });
	}

	removeToast(toast:any) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clearToasts() {
		this.toasts.splice(0, this.toasts.length);
	}
}


